import React from 'react'
import { useTranslation } from 'react-i18next'
import InlineSwitch from '../../common/InlineSwitch'
import { ItemTypes } from '../../../constants/constants'
import { useStore } from '../../../store/store'

const TableSplitSwitch = ({ box, isShowing, isVisible }) => {
  const { t } = useTranslation()
  const updateBox = useStore(({ updateBox }) => updateBox)
  const isAdmin = useStore(({ user }) => user?.isAdmin)
  const currentDocument = useStore(({ currentDocument }) => currentDocument)
  const splittableTables = useStore((state) => state.splittableTables)
  const zoneSplitTables = useStore((state) => state.zoneSplitTables)
  const storeColumns = useStore((state) => state.columns)

  if (!isVisible || box?.type !== ItemTypes.TABLE_VARIABLE) return null

  const isAdminTable = isAdmin && currentDocument?.type === 'template' && box?.tableName
  const isInDrawModeColumn = !!storeColumns?.find((c) => c.id === box?.columnId)?.drawMode
  const isSplittableTable =
    isAdminTable &&
    Array.isArray(splittableTables) &&
    splittableTables.some((item) => {
      if (typeof item === 'string') return item === box?.tableName
      return item?.tableName === box?.tableName || item?.table_name === box?.tableName
    })
  // Un tableau annoncé découpable par zone règle son découpage dans le Drawer
  // « Configurer le tableau » : pas de second interrupteur.
  const shouldShowSplitSwitch = !!(
    isSplittableTable &&
    !isInDrawModeColumn &&
    !zoneSplitTables?.includes(box?.tableName)
  )

  if (!shouldShowSplitSwitch) return null

  return (
    <InlineSwitch
      stopPropagation
      style={{ marginBottom: 8 }}
      start={
        <span style={{ whiteSpace: 'nowrap' }}>
          {t('table-split-modal-non-split')}
        </span>
      }
      end={
        <span style={{ whiteSpace: 'nowrap' }}>
          {t('table-split-modal-split')}
        </span>
      }
      size="small"
      disabled={isShowing}
      checked={!!box?.content?.shouldSplit}
      onChange={(checked) => {
        updateBox(box.id, (b) => {
          if (!b.content) b.content = {}
          b.content.shouldSplit = checked
          // Un identifiant de zone n'a de sens que sur une box découpée.
          if (!checked) delete b.content.identifiers
        })
      }}
    />
  )
}

export default TableSplitSwitch

